import { createContext, useContext, useState } from "react";

const MyCarContext = createContext();

export const MyCarContextProvider = ({ children }) => {
  const [stateContxt, setStateContxt] = useState({
    searchTextContxt: "",
    toggleStatusBtnContxt: "All",
  });
  return (
    <MyCarContext.Provider value={{ stateContxt, setStateContxt }}>
      {children}
    </MyCarContext.Provider>
  );
};

export const useMyCarContext = () => {
  const context = useContext(MyCarContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};
